import React, { useEffect, useState } from "react";
import { Theme } from "../../core/Models/CustomSiteConfigModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { ReactComponent as AudiomoversLogo } from "../../../assets/images/audiomovers-logo.svg";

import "./ServerError.css";

const ServerError: React.FC = () => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div
      className="server-error"
      style={{ backgroundColor: theme?.panelColour }}
    >
      <div
        className="server-error-container"
        style={{ color: theme?.textColor }}
      >
        <div className="logo">
          <a href="/">
            <AudiomoversLogo fill={theme?.textColor}></AudiomoversLogo>
          </a>
        </div>
        <div className="title" style={{ color: theme?.textColor }}>
          500 server error
        </div>
        <div className="stand-first" style={{ color: theme?.textColor }}>
          OOPS! WE’VE GOT A PROBLEM HERE
        </div>
        <div className="try-again" style={{ color: theme?.textColor }}>
          WE APOLOGISE FOR THE INCONVENIENCE. PLEASE TRY AGAIN LATER.
        </div>
      </div>
    </div>
  );
};

export default ServerError;
